export const errorVisualisationTitle = 'Внутренняя ошибка';
export const errorVisualisationDescription = 'Обратитесь за помощью к разработчику приложения';
